import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import Menudropdown from "./Menudropdown";
import { API_URL } from "../services/api";

function BatteryStatus({ site, setSelectedSite }) {
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!site) return;

        const fetchData = () => {
            axios.get(`${API_URL}/api/alldata?site=${site}`)
                .then(res => setStatus(res.data.response))
                .catch(err => {
                    console.error(err);
                    setError("Error getting data");
                });
        };

        fetchData(); // initial fetch
        const interval = setInterval(fetchData, 3000); // refresh every 3s
        return () => clearInterval(interval);
    }, [site]);

    // API Fehler
    if (error) return <p>{error}</p>;

    return (
        <div className="battery-data-container">
            <div className="dropdown-container">
                <Menudropdown onLocationChange={setSelectedSite} />
            </div>

            {!status ? (
                <p>load data...</p>
            ) : (
                <>
                    {/* Battery SOC */}
                    <div className="battery-soc">
                        <h2>Battery SOC</h2>
                        <div className="battery-container">
                            <div
                                className="battery-level"
                                style={{ height: `${status.battery_soc ?? 0}%` }}
                            ></div>
                        </div>
                        <h1>{status.battery_soc ?? "null"}%</h1>
                    </div>

                    {/* Local Hardware Table */}
                    <table className="Table1">
                        <thead>
                            <tr>
                                <th colSpan="2">Local Hardware</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Target Battery Power</td>
                                <td>{status.target_battery_power}</td>
                            </tr>
                            <tr>
                                <td>Battery Measured Power</td>
                                <td>{status.battery_measured_power ?? "null"}</td>
                            </tr>
                            <tr>
                                <td>Grid Connection Power</td>
                                <td>{status.grid_connection_power ?? "null"}</td>
                            </tr>
                            <tr>
                                <td>Total Active Power</td>
                                <td>{status.total_active_power}</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Controller Info */}
                    <div className="controller-wrapper">
                        <div className="controller-header">Controller</div>

                        <div className="controller-summary">
                            <p>Target Own Consumption Power: {status.target_own_consumption_power}</p>
                            <p>
                                Total Site Availability:
                                <span className={status.total_site_availability ? "green" : "red"}> ●</span>
                            </p>
                        </div>

                        <div className="controller-details">
                            <h3>Detailed Availability:</h3>
                            <ul className="detailed-availability">
                                <li>Power Meter: <span className={status.detailed_availability.power_meter ? "green" : "red"}>●</span></li>
                                <li>Battery: <span className={status.detailed_availability.battery ? "green" : "red"}>●</span></li>
                                <li>Subpooler: <span className={status.detailed_availability.subpooler ? "green" : "red"}>●</span></li>
                                <li>EMS: <span className={status.detailed_availability.ems ? "green" : "red"}>●</span></li>
                            </ul>
                        </div>

                        <div className="last-update">
                            Last Update: {status.last_update}
                        </div>
                    </div>
                    {/* Subpooler Table */}
                    <table className="Table2">
                        <thead>
                            <tr>
                                <th colSpan="2">Subpooler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Target Subpooler Power</td>
                                <td>{status.target_subpooler_power}</td>
                            </tr>
                            <tr>
                                <td>Battery Max Flexpower Charge</td>
                                <td>{status.battery_max_flexpower_chg}</td>
                            </tr>
                            <tr>
                                <td>Battery Max Flexpower Disharge</td>
                                <td>{status.battery_max_flexpower_dchg}</td>
                            </tr>
                            <tr>
                                <td>Battery Charge Preference</td>
                                <td>{status.battery_chg_preference}</td>
                            </tr>
                            <tr>
                                <td>Battery Discharge Preference</td>
                                <td>{status.battery_dchg_preference}</td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
}

export default BatteryStatus;
